import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function escapeHtml(unsafe: string): string {
    if (!unsafe) return '';
    return String(unsafe)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

export function generateSecureRandomString(length = 6): string {
  const charset = '0123456789abcdefghijklmnopqrstuvwxyz';
  let result = '';
  const array = new Uint32Array(length);
  window.crypto.getRandomValues(array);
  for (let i = 0; i < length; i++) {
    result += charset[array[i] % charset.length];
  }
  return result;
}

type FuncionarioNombreLike = {
    nombre?: string | null;
    apellido?: string | null;
    profiles?: { nombre?: string | null; apellido?: string | null } | null;
};

/**
 * Nombre completo de un funcionario. Usa profiles.nombre/apellido si tiene
 * cuenta de auth vinculada; si no (funcionarios importados masivamente sin
 * cuenta), cae a funcionarios.nombre/apellido.
 */
export function getNombreCompleto(f: FuncionarioNombreLike | null | undefined, fallback = ''): string {
    if (!f) return fallback;
    // || (no ??): un profiles.nombre en blanco también debe caer a funcionarios.nombre
    // Va || y no ??: el personal cargado en lote no tiene cuenta, así que profiles
    // viene nulo y el nombre vive en el propio funcionario. Un string vacío también
    // tiene que caer al siguiente, no cortar la cadena.
    const nombre = f.profiles?.nombre || f.nombre || '';
    const apellido = f.profiles?.apellido || f.apellido || '';
    const full = `${nombre} ${apellido}`.trim();
    return full || fallback;
}

export function generateComplexPassword(length = 12): string {
    const charsetLowercase = "abcdefghijklmnopqrstuvwxyz";
    const charsetUppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const charsetNumbers = "0123456789";
    const charsetSpecial = "!@#$%^&*()_+~`|}{[]:;?><,./-=";

    const allCharsets = charsetLowercase + charsetUppercase + charsetNumbers + charsetSpecial;

    let password = "";

    // Ensure at least one character from each set
    const randomVals = new Uint32Array(length);
    window.crypto.getRandomValues(randomVals);

    password += charsetLowercase[randomVals[0] % charsetLowercase.length];
    password += charsetUppercase[randomVals[1] % charsetUppercase.length];
    password += charsetNumbers[randomVals[2] % charsetNumbers.length];
    password += charsetSpecial[randomVals[3] % charsetSpecial.length];

    // Fill the rest with random characters from all sets
    for (let i = 4; i < length; i++) {
        password += allCharsets[randomVals[i] % allCharsets.length];
    }

    // Shuffle the characters
    const passwordArray = password.split('');
    const shuffleVals = new Uint32Array(length);
    window.crypto.getRandomValues(shuffleVals);

    for (let i = length - 1; i > 0; i--) {
        const j = shuffleVals[i] % (i + 1);
        const temp = passwordArray[i];
        passwordArray[i] = passwordArray[j];
        passwordArray[j] = temp;
    }

    return passwordArray.join('');
}
